import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { HeadquarterStorageModalComponent } from 'src/app/shared/components/modals/headquarter/headquarter-storage-modal/headquarter-storage-modal.component';
import { HeadquarterModalComponent } from 'src/app/shared/components/modals/headquarter/headquarter-modal.component';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-headquarter',
  templateUrl: './headquarter.component.html',
  styleUrls: ['./headquarter.component.css']
})
export class HeadquarterComponent implements OnInit {
  loading: boolean = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['index','name','description','nomenclature','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isAdminGys: boolean = false;
  countMaxUserByEnterprise: number = 0;
  enterprises = [];
  subscription: Subscription;
  enterpriseSelect: number = 0;
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  length: number = 0;
  page: number = 1;
  headquarterSelect = 0;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  enabledRead: number;
  enabledWrite: number;
  searchText: string = '';
  timer:any;
  timeoutVal = 800;

  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private enterpriseService: EnterpriseService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private emitterService: EmitterService,
    private headquarterService: HeadquarterService,
    ) {
      document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Sedes</span>';
    }

  ngOnInit() {
    this.setLS();
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = '';
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    //this.getEnterprises();
    this.getList();
    this.subscription = this.emitterService.getMessage().subscribe(message => {
      if (message == AppConstants.EmitterService.ListUsers) {
        this.getList();
      }
      if (message == AppConstants.EmitterService.ListUsersEdit) {
        this.getList();
      }
    });
  }

  setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  /*changeEnterprise(data) {
    var e = this.enterprises.find(f => f.enterpriseId == data.value);
    if(e != null){
      this.countMaxUserByEnterprise = e.maximumUsers;
      this.enterpriseSelect = data.value;
      this.headquarterStorageEnabled =  e.headquarterStorageEnabled;
      this.getList();
    }
  }

  getEnterprises() {
    if (this.isAdminGys) {
      this.spinner.show();
      this.enterpriseService.getEnterprises().subscribe((response) => {
        this.enterprises = response.filter(f => f.enabled == AppConstants.Flag.Active);
        this.enterpriseSelect = this.enterprises[0]["enterpriseId"];
        this.countMaxUserByEnterprise = this.enterprises[0]["maximumUsers"];
        this.headquarterStorageEnabled =  this.enterprises[0]["headquarterStorageEnabled"];
        this.getList();
        this.spinner.hide();
      },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        });
    } else {
      this.enterpriseSelect = +localStorage.getItem(AppConstants.Session.ENTERPRISE)
      this.getEnterpriseById(this.enterpriseSelect);
      this.getList();
    }
  }*/

  getEnterpriseById(enterpriseId: number) {
    this.spinner.show();
    this.enterpriseService.getEnterpriseById(enterpriseId).subscribe((response => {
      this.countMaxUserByEnterprise = response.maximumUsers;
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getList(){
    var filter = {
      Page: this.page,
      Rows: AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION,
      IdEnterprise: this.enterpriseSelect,
      Filter: this.searchText
    };
    this.spinner.show();
    this.headquarterService.getList(filter).subscribe((_) => {
      if(_.error == null){
       // var data;
        /*if(this.headquarterSelect>0){
          data = _["rows"].filter(x => x.id == this.headquarterSelect);
        }else{
          data = _["rows"];
        }*/
        var data = _["rows"];
        this.dataSource = new MatTableDataSource(data);
        this.pageIndex = +_["page"]-1;
        this.length = _["total"];
        console.log("data",data);
      }
      this.spinner.hide();
    });
  }

  getServerData(event?: PageEvent) {
    this.page = event.pageIndex + 1;
    this.getList();
  }

  openAddModal() {
    let dialogRef = this.dialog.open(HeadquarterModalComponent, {
      data: {
        title: AppConstants.TitleModal.CREATE_HEADQUARTER,
        action: AppConstants.OperationType.ADD,
        idEnterprise: this.enterpriseSelect,
        isAdminGys: this.isAdminGys ,
        enabledWrite: true,//this.enabledWrite,
        enabledRead: this.enabledRead,
        obj:null,
        color: this.color1,
        colorFont: this.color2},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        this.page = 1;
        this.paginator.pageIndex = 0;
        this.getList();
      }
    });
  }

  openEditModal(data){
      let dialogRef = this.dialog.open(HeadquarterModalComponent, {
        data: {
          title: AppConstants.TitleModal.UPDATE_HEADQUARTER,
          action: AppConstants.OperationType.UPDATE,
          idEnterprise: this.enterpriseSelect,
          isAdminGys: this.isAdminGys,obj:data,
          color: this.color1,
          enabledWrite: this.enabledWrite,
          enabledRead: this.enabledRead,
          colorFont: this.color2},
        width: '500px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
        if (_.result == true) {
          this.getList();
        }
      });
  }

  openSettingModal(data){
    let dialogRef = this.dialog.open(HeadquarterStorageModalComponent, {
      data: {
        title: AppConstants.TitleModal.UPDATE_HEADQUARTER_FILE,
        action: AppConstants.OperationType.UPDATE,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: data.id,
        isAdminGys: this.isAdminGys,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        color: this.color1,
        colorFont: this.color2
      },
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        this.getList();
      }
    });
  }

  delete(obj) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.DELETE_DEFAULT}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteSecurity(obj.id);
      }
    });

  }

    deleteSecurity(id: number) {
      this.spinner.show();
      this.headquarterService.delete(id).subscribe((response => {
        this.spinner.hide();
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_HEADQUARTER, AppConstants.MessageModal.DELETE, MessageSeverity.success);
        this.getList();
      }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_HEADQUARTER, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
      });
    }

    applyUpFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.searchText = filterValue.trim().toLowerCase();
        var _this = this;
        window.clearTimeout(_this.timer);
          _this.timer = window.setTimeout(() => {
              _this.page = 1;
              _this.paginator.pageIndex = 0;
              _this.getList();
            }, _this.timeoutVal);
    }

    applyPressFilter(event: Event) {
      var _this = this;
      window.clearTimeout(_this.timer);
    }
}
